import type { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/features.routes').then((m) => m.featuresRoutes)
  },
  {
    path: 'auth',
    loadChildren: () => import('./core/auth/auth.routes').then((m) => m.authRoutes)
  },
  {
    path: 'public',
    loadChildren: () => import('./public/public.routes').then((m) => m.publicRoutes)
  },
  {
    path: 'validation',
    loadComponent: () =>
      import('./public/validation/validation.component').then((m) => m.ValidationComponent)
  }
];
